/*
This file was generated by the Surface compiler.
*/

export const companySelector = {
  mounted() {
    let target

    if (this.el.dataset.targetId) {
      target = `#${this.el.dataset.targetId}`
    } else {
      target = this.el
    }

    this.el.addEventListener("autocomplete:item-select", (e) => {
      this.pushEventTo(target, this.el.dataset.onSelect, e.detail.data)

      if (e.detail.data == "enaia:skip_options") {
        const websiteInput = document.getElementById(
          this.el.dataset.websiteInputSelector,
        )
        // Selectorless callers (EditContact, SimpleContactForm) omit
        // website_input_selector — they have no domain field to focus, so
        // "None of these options" is an expected no-op. Only a *configured*
        // selector that matches no element signals a regressed ENA-9560
        // crash, so surface that loudly (LogRocket captures console.error)
        // instead of failing silently or spamming the expected path.
        if (!websiteInput) {
          if (this.el.dataset.websiteInputSelector) {
            console.error(
              `[companySelector] websiteInputSelector "${this.el.dataset.websiteInputSelector}" matched no element`,
            )
          }
          return
        }

        websiteInput.focus()

        if (websiteInput.disabled) {
          inputDisabledStateObserver.observe(websiteInput, {
            attributes: true,
          })
        }
      }
    })
    this.el.addEventListener("autocomplete:leaving", (e) => {
      this.pushEventTo(target, this.el.dataset.onEnterOrBlur, {
        value: e.target.value,
      })
    })
    const displayInput = this.el.querySelector('input[type="text"]')
    displayInput.addEventListener("input", (e) => {
      const onCompanyNameClear = this.el.dataset.onCompanyNameClear
      const onCompanyNameOverride = this.el.dataset.onCompanyNameOverride

      if (e.target.value == "" && onCompanyNameClear) {
        this.pushEventTo(target, onCompanyNameClear, {
          value: e.target.value,
        })
      }
      if (e.target.value != "" && onCompanyNameOverride) {
        this.pushEventTo(target, onCompanyNameOverride, {
          value: e.target.value,
        })
      }
    })
  },
}

// Company autocomplete is powered by the Brandfetch Brand Search API
// (https://docs.brandfetch.com/brand-search-api/overview). It's a free product
// with a public clientId, so we call it directly from the browser — this keeps
// the rate limit per-user (per-IP) instead of shared across our egress IPs and
// removes a server hop. The clientId is exposed via `window.brandfetchClientId`
// (see root.html.heex). Errors resolve to an empty list so a Brandfetch outage
// degrades to "no suggestions" rather than breaking the input.
//
// Assigned with `??=` (not `=`) so a test harness that pre-installs a mock on
// `window.fetchCompaniesForAutocomplete` via addInitScript (runs before this
// bundle — see test/int_support/feature_helpers/mocks.ex) wins and we don't
// clobber it. In production nothing pre-defines it, so this is what runs.
window.fetchCompaniesForAutocomplete ??= async (query) => {
  if (query == "") return []

  const clientId = window.brandfetchClientId
  if (!clientId) return []

  let raw_data
  try {
    const response = await fetch(
      `https://api.brandfetch.io/v2/search/${encodeURIComponent(query)}?c=${encodeURIComponent(clientId)}`,
    )
    if (!response.ok) return []
    raw_data = await response.json()
  } catch {
    return []
  }

  if (!Array.isArray(raw_data)) return []

  // Brandfetch Search returns [{name, domain, icon, claimed, brandId}]; map it
  // onto the {name, domain, logo} shape the rest of the flow already consumes.
  // Brandfetch allows null name/domain, so drop results missing either —
  // otherwise we'd render "null (example.com)" and push a null company name
  // into the account/contact form on selection.
  const data = dedupe(
    raw_data.filter((company) => company.domain && company.name),
    "domain",
  ).map((company) => ({
    data: { name: company.name, domain: company.domain, logo: company.icon },
    optionText: company.name + " (" + company.domain + ")",
    selectionText: company.name,
    imageUrl: company.icon,
  }))

  if (data.length > 0) {
    data.push({
      data: "enaia:skip_options",
      optionText: "None of these options",
      selectionText: "",
      imageUrl: false,
    })
  }

  return data
}

function dedupe(array_of_objects, field_criteria) {
  return array_of_objects.reduce((acc, value) => {
    const array_of_attrs = acc.map((object) => object[field_criteria])
    if (!array_of_attrs.includes(value[field_criteria])) {
      acc.push(value)
      return acc
    }
    return acc
  }, [])
}

var inputDisabledStateObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (mutation.attributeName === "disabled") {
      mutation.target.focus()
      inputDisabledStateObserver.disconnect()
    }
  })
})
